import React from "react";
import { Row, Col } from "react-bootstrap";
import moment from "moment";
import styled from "styled-components";

const Styled = {};

Styled.RecurringPaymentBox = styled.div`
  border-radius: 6px;
  background-color: rgb(203, 230, 251);
  color: #000;
  padding: 20px;
  font-size: 1rem;
  margin: 15px 0 0px;
`;

Styled.RecurringPaymentBoxText = styled.p`
  display: block;
  font-size: 15px;
  color: #222;
  font-style: italic;
  margin-bottom: 0;
`;

const RecurringPaymentBox = ({ recurringPayment }) => {
  return (
    <Row>
      <Col sm={12}>
        <Styled.RecurringPaymentBox>
          <Styled.RecurringPaymentBoxText>
            You have a recurring payment set up from your{" "}
            <strong style={{ textTransform: "capitalize" }}>{recurringPayment.InstitutionName}</strong>{" "}
            account ending in <strong>{recurringPayment.AccountLastFour}</strong>. The next scheduled payment date{" "}
            <strong>{recurringPayment.NextScheduledDtTm === null
              ? "has not been scheduled"
              : `is scheduled for ${moment(recurringPayment.NextScheduledDtTm).format(
                  "MM/DD/YYYY"
                )}`}</strong>
            .
          </Styled.RecurringPaymentBoxText>
        </Styled.RecurringPaymentBox>
      </Col>
    </Row>
  );
};

export default RecurringPaymentBox;



// WEBPACK FOOTER //
// ./src/components/recurring-payment-box/recurring-payment-box.component.js